











import { COLOR_BLACK_TEXT, COLOR_BLACK_TEXT_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class PanelStatusEntryComponent extends Vue {
  @Prop() label!: string;
  @Prop() text!: string;
  @Prop({ default: "" }) textColor!: string;

  /**
   * Text color for the entry value. When the parent supplies an explicit color
   * it is used as-is; otherwise it falls back to a theme-aware body-text color
   * (black in light mode, white in dark mode) so the value stays readable.
   */
  get effectiveTextColor(): string {
    return this.textColor !== "" ? this.textColor : themed(COLOR_BLACK_TEXT, COLOR_BLACK_TEXT_DARK);
  }
}
